import {
  AUTO_SELECT_HOTEL_FAILED,
  AUTO_SELECT_HOTEL_STARTED,
  AUTO_SELECTED_HOTEL
} from 'actions/actionTypes'
import { LOCATION_CHANGE } from 'connected-react-router'

export default function appStateReducer(
  state = {
    activeScreen: '',
    currentUser: '',
    userToken: '',
    userLoggedIn: false,
    currentHotel: '',
    currentHotelShort: '',
    currentHotelId: '',
    currentUtcOffset: null,
    sessionExpired: false,
    sessionId: null,
    userNotAuthorized: false,
    isAppReloading: false,
    subsidiaryList: [],
    isSubsidiaryPosted: false,
    isSubsidiaryPosting: false,
    tryingLogIn: true,
    merchantDetails: {},
    subsidiaryPMS: null,
    currentPmsNeedSync: false,
    actuallyIsInternalAdmin: false,
    isInternalAdmin: false,
    isCsmUser: false,
    csmUserId: null,
    hasBillingContact: null,
    hasTripAdvisorLink: null,
    prevPath: '/analytics',
    locale: 'en-US',
    currency: 'USD',
    roles: {},
    //activeServices: ['marketingWithCommission', 'marketing', 'messaging'],
    //activeServices: ['marketingWithCommission', 'marketing']
    //activeServices: ['messaging'],
    activeServices: [],
    isGroupLevelUser: false,
    isDemoMode: false
  },
  action
) {
  switch (action.type) {
    case LOCATION_CHANGE: {
      return {
        ...state,
        userNotAuthorized: false
      }
    }

    case 'UPDATE_PMS_NEED_SYNC':
      return {
        ...state,
        currentPmsNeedSync: action.payload
      }

    case 'UPDATE_USER_INFO': {
      const { fullName, phone, email } = action.payload

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          fullName,
          phone,
          email
        }
      }
    }

    case 'NO_LOGIN_INFO_FOUND':
      return {
        ...state,
        tryingLogIn: false
      }

    case 'UPDATE_APP_STATE':
      return {
        ...state,
        ...action.payload
      }
    case 'SWAYPAY_INITED':
      return {
        ...state,
        swayPayInited: true
      }

    case 'USER_LOGGED_IN':
      return {
        ...state,
        userToken: action.payload.userToken,
        userId: action.payload.userId,
        currentUser: action.payload.currentUser,
        userLoggedIn: true,
        tryingLogIn: false,
        isAppReloading: false,
        sessionId: action.payload.sessionId
      }

    case 'USER_LOGGED_OUT':
      return {
        ...state,
        currentUser: '',
        userToken: '',
        userLoggedIn: false,
        currentHotel: '',
        currentHotelShort: '',
        currentHotelId: '',
        subsidiaryList: [],
        isSubsidiaryPosted: false,
        merchantDetails: {},
        qrLoggingIn: 0,
        userNotAuthorized: false,
        sessionId: null
      }

    case 'LOG_OUT_FROM_CURRENT_HOTEL':
      return {
        ...state,
        currentHotel: '',
        currentHotelShort: '',
        currentHotelId: '',
        subsidiaryList: [],
        isSubsidiaryPosted: false
      }

    // case 'UPDATE_CURRENT_HOTEL':
    //   return {
    //     ...state,
    //     currentHotel: action.payload.subsidiaryName,
    //     currentHotelShort: action.payload.subsidiaryNameForText,
    //     currentHotelId: action.payload.subsidiaryId,
    //     subsidiaryPMS: action.payload.subsidiaryPMS,
    //     isAppReloading: false,
    //     currentPmsNeedSync: action.payload.currentPmsNeedSync,
    //     sessionExpired: false
    //   }

    case 'POST_AND_SELECT_SUBSIDIARY_STARTED':
      return {
        ...state,
        isSubsidiaryPosted: false,
        isSubsidiaryPosting: true,
        isAppReloading: true,
        currentHotel: '',
        currentHotelShort: '',
        currentHotelId: '',
        subsidiaryPMS: '',
        currentPmsNeedSync: ''
      }

    case 'SAVE_POSTED_SUBSIDIARY': {
      const {
        currentHotel,
        currentHotelShort,
        currentHotelId,
        currentUtcOffset,
        subsidiaryPMS,
        currentPmsNeedSync,
        shouldAskAddBillingContact,
        hasTripAdvisorLink,
        hasBillingContact,
        roles,
        activeServices,
        isGroupLevelUser,
        isCsmUser,
        csmUserId
      } = action.payload

      return {
        ...state,
        currentHotel,
        currentHotelShort,
        currentHotelId,
        currentUtcOffset,
        subsidiaryPMS,
        currentPmsNeedSync,
        shouldAskAddBillingContact,
        hasTripAdvisorLink,
        hasBillingContact,
        isSubsidiaryPosted: true,
        isSubsidiaryPosting: false,
        isAppReloading: false,
        activeServices,
        isGroupLevelUser,
        isCsmUser,
        csmUserId,
        roles: roles.reduce(
          (prev, curr) => ({ ...prev, [curr.role]: curr.accessLevel }),
          {}
        )
      }
    }

    case 'SET_SUBSIDIARY_POSTED':
      return {
        ...state,
        isSubsidiaryPosted: true
      }

    case 'SESSION_TIMED_OUT':
      return {
        ...state,
        isAppReloading: state.sessionExpired ? false : true,
        sessionTimedOut: true
      }

    case 'SESSION_RENEWED':
      return {
        ...state,
        isAppReloading: false,
        sessionTimedOut: false,
        sessionId: action.payload
      }

    case 'EXPIRE_SESSION':
      return {
        ...state,
        sessionExpired: true,
        currentUser: '',
        userLoggedIn: false,
        currentHotel: '',
        subsidiaryList: [],
        isSubsidiaryPosted: false,
        merchantDetails: {},
        qrLoggingIn: 0,
        activeScreen: 'login',
        isAppReloading: false,
        sessionId: null,
        tryingLogIn: false
      }

    case 'REJECT_ADD_BILLING_CONTACT':
      return {
        ...state,
        shouldAskAddBillingContact: false
      }

    case 'GET_SUBSIDIARY_LIST_STARTED':
      return {
        ...state,
        isAppReloading: true
      }

    case 'SAVE_SUBSIDIARY_LIST':
      return {
        ...state,
        subsidiaryList: action.payload.subsidiaries,
        actuallyIsInternalAdmin: action.payload.isInternalAdmin,
        isInternalAdmin: action.payload.isInternalAdmin,
        isCsmUser: action.payload.isCsmUser,
        csmUserId: action.payload.csmUserId,
        isAppReloading: false
      }

    case 'SET_SESSION':
      return {
        ...state,
        sessionExpired: false,
        sessionTimedOut: false,
        isAppReloading: false,
        sessionId: action.payload
      }

    case 'SET_USER_NOT_AUTHORIZED':
      return {
        ...state,
        userNotAuthorized: true
      }

    case 'SET_USER_AUTHORIZED':
      return {
        ...state,
        userNotAuthorized: false
      }

    case 'QR_LOGGING_IN':
      return {
        ...state,
        qrLoggingIn: 1,
        sessionExpired: false
      }

    case 'SAVE_PREV_PATH':
      return {
        ...state,
        prevPath: action.payload
      }

    case 'SET_TRYING_LOG_IN':
      return {
        ...state,
        tryingLogIn: true,
        isAppReloading: true
      }

    case 'TRYING_TO_LOG_IN':
      return {
        ...state,
        isAppReloading: true
      }

    case 'UPDATE_MERCHANT_DETAILS':
      return {
        ...state,
        merchantDetails: action.payload.merchantDetails
      }

    case 'IS_INTERNAL_ADMIN':
      return {
        ...state,
        isInternalAdmin: true
      }

    case 'NOT_INTERNAL_ADMIN':
      return {
        ...state,
        isInternalAdmin: false
      }

    case 'DEMO_MODE_OFF':
      return {
        ...state,
        isDemoMode: false
      }

    case 'DEMO_MODE_ON':
      return {
        ...state,
        isDemoMode: true
      }

    case 'ON_DIRECT_INVOICE':
      return {
        ...state,
        isAppReloading: false
      }

    case AUTO_SELECT_HOTEL_STARTED:
      return {
        ...state,
        isAppReloading: true
      }

    case AUTO_SELECTED_HOTEL:
      return {
        ...state,
        isAppReloading: false
      }

    case AUTO_SELECT_HOTEL_FAILED:
      return {
        ...state,
        isAppReloading: false
      }

    default:
      return state
  }
}

export function dashboardApp(state = {}, action) {
  return {
    appState: appStateReducer(state.appState, action)
  }
}

export function rootReducer(state, action) {
  return dashboardApp(state, action)
}
